import { clsx } from 'clsx';

import { OperationType, OperationTypeIcons } from '@/api/enums/OperationType.ts';
import { OperatorType } from '@/api/enums/Operators.ts';
import { Operation } from '@/api/types';
import { Collapsible } from '@/components/shared/Collapsible/Collapsible.tsx';
import { formatNumberToStr, getEnumKeyByValue } from '@/utils';

import cn from './styles.module.sass';

interface ITransactionListProps {
    date: string;
    timeZone: string;
    operations: Operation[];
}

export const OperationList = ({ date, operations }: ITransactionListProps) => {
    return (
        <div className={cn.container}>
            <h3 className={cn.date}>{date}</h3>
            <div className={cn.operations}>
                {operations.map(operation => (
                    <Collapsible
                        containerClassName={cn.collapsibleContainer}
                        key={operation.id}
                        isNumberInTitle
                        isExpandable={false}
                        isArrowShown={false}
                        title={formatNumberToStr(operation.msisdn)}
                        description={getEnumKeyByValue(OperationType, operation.type)}
                        operator={
                            operation.type === 3 || operation.type === 1
                                ? getEnumKeyByValue(OperatorType, operation.operatorId) ||
                                  'drugomaniya'
                                : getEnumKeyByValue(OperationTypeIcons, operation.type)
                        }
                        rightContent={
                            <span className={clsx(cn.points, operation.sum < 0 && cn.negative)}>
                                {operation.sum} Б
                            </span>
                        }
                    />
                ))}
            </div>
        </div>
    );
};
